import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const saveUnit = async (unit, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            let Payload = {
                unitID: unit?.unitID || 0,
                unitName: unit?.unitName,
                unitSymbol: unit?.unitSymbol,
                isActive: unit?.isActive !== undefined ? unit.isActive : true,
            };

            const response = await fetch(`${dev_baseUrl}/Material/saveUnit`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(Payload),
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred. Please try again later.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};

export const getUnits = async (unitID, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            // Build query parameters
            const queryParams = unitID !== undefined ? `?unitID=${unitID}` : '';
            
            const response = await fetch(`${dev_baseUrl}/Material/getUnits${queryParams}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred while fetching units.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};

export const deleteUnit = async (unitID, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            const queryParams = new URLSearchParams({
                unitID: unitID 
            }).toString();

            const response = await fetch(`${dev_baseUrl}/Material/deleteUnit?${queryParams}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else if(response.ok && !data.isError ){
                return data.result;
            } 
            else {
                console.error('Server error:', data);
                const errorMessage = data.message || "Unit failed to delete.";
                if (errorMessage.toLowerCase().includes('not found') || 
                    errorMessage.toLowerCase().includes('default')) {
                    return {
                        isError: true,
                        message: "Default units cannot be deleted",
                    };
                }
                
                return {
                    isError: true,
                    message: errorMessage,
                };
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred while deleting unit.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { 
            isError: true,
            form: "Access token is missing." 
        };
    }
};